import { Context } from "../Engine";
import { Scene } from "../Scene";
import { Camera } from "../View/Camera";
import { RenderMode } from "../Object/ObjectManager";
import { SceneRenderer } from "./SceneRenderer";
import { RenderedTexture } from "../Texture";
import { DefaultSceneRenderer } from "./DefaultSceneRenderer";
import { VolumetricLightOverlay, TextureOverlay, AdditiveBlendOverlay } from "../Object/Overlay";
import { project } from "@spi/Common/Math";
import { vec3, vec2 } from "gl-matrix";

export class MultiPassSceneRenderer extends SceneRenderer {

    private occlusionLayer: RenderedTexture;
    private lightLayer: RenderedTexture;
    private regularSceneLayer: RenderedTexture;

    private defaultRenderer: DefaultSceneRenderer;
    private lightOverlay: VolumetricLightOverlay;
    private additiveLayer: AdditiveBlendOverlay;
    private ctx: Context;

    public init(ctx: Context): void {
        this.ctx = ctx;
        this.occlusionLayer = new RenderedTexture();
        this.occlusionLayer.init(ctx);

        this.lightLayer = new RenderedTexture();
        this.lightLayer.init(ctx);

        this.regularSceneLayer = new RenderedTexture();
        this.regularSceneLayer.init(ctx);

        this.defaultRenderer = new DefaultSceneRenderer();
        this.defaultRenderer.init(ctx);

        this.lightOverlay = new VolumetricLightOverlay(ctx, this.occlusionLayer);


        this.additiveLayer = new AdditiveBlendOverlay(ctx, this.lightLayer, this.regularSceneLayer);
    }
    public destroy(): void {

    }
    public render(scene: Scene, camera: Camera, buffer: WebGLFramebuffer): void {
        const gl = scene.ctx.gl;

        let v4pos = scene.lightManager.lights[0].position;
        let pos = vec3.fromValues(v4pos[0], v4pos[1], v4pos[2]);

        let projected = project(pos, camera.projectionMatrix, camera.modelViewMatrix, this.ctx.viewPort);

        let lightPos = vec2.fromValues(projected[0], projected[1]);

        let diplayLight = projected[2] <= 1;

        this.defaultRenderer.renderMode = RenderMode.Occlusion;
        this.defaultRenderer.preRender = true;

        gl.bindFramebuffer(gl.FRAMEBUFFER, this.occlusionLayer.buffer);
        this.occlusionLayer.renderTexture(this.defaultRenderer, scene, camera);

        gl.bindFramebuffer(gl.FRAMEBUFFER, this.lightLayer.buffer);
        gl.viewport(0, 0, this.ctx.viewPort.width, this.ctx.viewPort.height);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        if (diplayLight) {
            vec2.normalize(lightPos, lightPos);
            //console.log(lightPos);
            //this.lightOverlay.settings.lightPosition = [0,0];
            this.lightOverlay.render(scene.ctx, camera, { mode: RenderMode.Primary });
        }

        // gl.bindFramebuffer(gl.FRAMEBUFFER, this.regularSceneLayer.buffer);
        // gl.viewport(0, 0, this.ctx.viewPort.width, this.ctx.viewPort.height);
        // gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        this.defaultRenderer.renderMode = RenderMode.Primary;
        this.defaultRenderer.render(scene, camera, this.regularSceneLayer.buffer);

        gl.bindFramebuffer(gl.FRAMEBUFFER, buffer);
        gl.viewport(0, 0, this.ctx.viewPort.width, this.ctx.viewPort.height);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        this.additiveLayer.render(scene.ctx, camera, { mode: RenderMode.Primary });

    }

}